import {
  AdminUploadManagement,
  ProviderUploadManagement,
  UserUploadManagement,
} from 'pages/uploads/components';

import { useQueryClient } from '@tanstack/react-query';

import { useCanAccess } from 'hooks/useCanAccess';
import { useIsProvider } from 'hooks/useIsProvider';
import { Unauthorized } from 'components/unauthorized';
import { TokenExpired } from 'components/tokenExpired';
import { useCurrentSiteStore } from 'store/SiteStore';
import { useCurrentUserStore } from 'store/UserStore';

export const UploadManagementRoute = () => {
  const { canAccess, isAdmin, isExpired } = useCanAccess('uploads');
  const isProvider = useIsProvider();
  const queryClient = useQueryClient();
  const { allowUploads, providerSiteSelection } = useCurrentSiteStore();
  const { providers } = useCurrentUserStore();
  const isAllSites = providerSiteSelection === 'all';
  const providerAllSitesAllowUploads =
    isProvider &&
    isAllSites &&
    providers?.some((provider) =>
      provider.sites?.some((site) => site.allowUploads)
    );

  if (!allowUploads && !providerAllSitesAllowUploads) {
    return <Unauthorized />;
  }

  return isExpired ? (
    <TokenExpired />
  ) : isAdmin ? (
    <AdminUploadManagement queryClient={queryClient} />
  ) : isProvider && canAccess ? (
    <ProviderUploadManagement queryClient={queryClient} />
  ) : canAccess ? (
    <UserUploadManagement queryClient={queryClient} />
  ) : (
    <Unauthorized />
  );
};
